import { useEffect, useState, createRef, useRef } from 'react';
import { buildQuickview, Result } from '@coveo/headless';
import { useCoveoSearchEngine } from '../CoveoSearchEngine';
import { Link } from '@lmig/lmds-react-link';
import { Modal, ModalBody, ModalHeader } from '@lmig/lmds-react-modal';
import PreviewDoc from 'Images/Preview_Doc_RGB.svg';

interface IQuickviewProps {
  result: Result;
  modalClass?: string;
}
export function Quickview({ result, modalClass }: IQuickviewProps) {
  const { headlessEngine } = useCoveoSearchEngine();
  const quickView = useRef(buildQuickview(headlessEngine!, { options: { result } }));
  const [isModalOpen, toggleModal] = useState(false);
  const iframeRef = createRef<HTMLIFrameElement>();
  const [quickViewState, setQuickViewState] = useState(quickView.current.state);
  useEffect(() => {
    const unsub = quickView.current.subscribe(() => setQuickViewState(quickView.current.state));
    return function cleanup() {
      unsub();
    };
  }, []);
  const openModal = () => {
    quickView.current.fetchResultContent();
    toggleModal(true);
  };
  const closeModal = () => toggleModal(false);
  function showIcon() {
    return (
      <Link
        className="quick-view-link caption"
        onClick={() => {
          openModal();
        }}
      >
        <PreviewDoc style={{ verticalAlign: 'top', height: '16px' }} />
      </Link>
    );
  }
  function fixIframe() {
    if (iframeRef.current) {
      iframeRef.current.height = iframeRef.current?.contentWindow
        ? iframeRef.current!.contentWindow.document.body.scrollHeight + 25 + 'px'
        : '';
    }
  }
  if (!quickViewState.resultHasPreview) {
    return null;
  }
  if (isModalOpen) {
    return (
      <>
        {showIcon()}
        <Modal isOpen={isModalOpen} size="large" className={modalClass ? modalClass : ''} onClose={() => closeModal()}>
          <ModalBody>
            <ModalHeader>{result.title}</ModalHeader>
            <iframe
              ref={iframeRef}
              title="Search Result Quick View"
              srcDoc={quickViewState.content}
              className="quick-view-content"
              onLoad={() => fixIframe()}
            ></iframe>
          </ModalBody>
        </Modal>
      </>
    );
  }
  return showIcon();
}
